import {urlForSpace} from "@src/utils/endpoints-urls";


export function urlForTimedShuttles(spaceId: string): string {
	return `${urlForSpace(spaceId)}/timed-shuttle`;
}

export function urlForTimedShuttlesInstances(spaceId: string, date: string): string {
return `${urlForTimedShuttles(spaceId)}/instances?date=${date}`;
}

export function urlForTimedShuttleInstance(
	spaceId: string,
	rideId: string
  ): string {
	return `${urlForTimedShuttles(spaceId)}/instances/${rideId}`;
  }

export function urlForTimedShuttlesDefinitions(spaceId: string): string {
	return `${urlForTimedShuttles(spaceId)}/definitions`;
}

/** POST a single instance for one definition */
export function urlForTimedShuttleDefinitionInstances(
	spaceId: string,
	definitionId: string
  ): string {
	return `${urlForTimedShuttles(spaceId)}/instances`;
  }

export function urlForTimedShuttleInstanceParticipants(
  spaceId: string,
  rideId: string
): string {
  return`${urlForTimedShuttleInstance(spaceId, rideId)}/participants`;
}
